module.exports = __webpack_public_path__ + "img/frank-emory-bunts.1cf62c38.png";